
export const SPRITE_PATHS = {
  "default": "/_nuxt/nuxt-svg/sprite-default.UaiVxFhmpvadFqRe11pLD-jn-65GGzHJ-u7sFpAbByw.svg"
}
export const runtimeOptions = {"ariaHidden":true}
